export const Actions = {
  EMAIL: 'email-marketing-reward'
}
